module.exports = __webpack_public_path__ + "static/media/24b.40ef9d6f.jpg";